import React from 'react';
import { IIconProps } from './utils';

export const Inquiry = ({
  fill = 'currentColor', height = 30, width = 30, ...rest
}: IIconProps) => (
  <svg
    fill="none"
    height={height}
    viewBox="0 0 30 30"
    width={width}
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    <path
      clipRule="evenodd"
      d="M5 5C2.92893 5 1.25 6.67893 1.25 8.75V20C1.25 22.0711 2.92893 23.75 5 23.75H10.2145C10.546 23.75 10.8639 23.8817 11.0983 24.1161L13.2322 26.25C14.2085 27.2263 15.7915 27.2263 16.7678 26.25L18.9017 24.1161C19.1361 23.8817 19.454 23.75 19.7855 23.75H25C27.0711 23.75 28.75 22.0711 28.75 20V8.75C28.75 6.67893 27.0711 5 25 5H23.75C23.0596 5 22.5 5.55964 22.5 6.25C22.5 6.94036 23.0596 7.5 23.75 7.5H25C25.6904 7.5 26.25 8.05964 26.25 8.75V20C26.25 20.6904 25.6904 21.25 25 21.25H19.7855C18.791 21.25 17.8371 21.6451 17.1339 22.3483L15 24.4822L12.8661 22.3484C12.1629 21.6451 11.209 21.25 10.2145 21.25H5C4.30964 21.25 3.75 20.6904 3.75 20V8.75C3.75 8.05964 4.30964 7.5 5 7.5H18.75C19.4404 7.5 20 6.94036 20 6.25C20 5.55964 19.4404 5 18.75 5H5ZM13.5813 11.8771C13.925 11.2845 14.6911 11.0772 15.2921 11.4227C15.89 11.7664 16.0906 12.5225 15.7488 13.1119C15.577 13.4081 15.3021 13.6075 14.9899 13.6908C14.3229 13.8688 13.9264 14.5537 14.1043 15.2208C14.2823 15.8878 14.9673 16.2843 15.6343 16.1064C16.5581 15.8599 17.3929 15.2602 17.9115 14.366C18.9504 12.5745 18.3316 10.2862 16.538 9.25526C14.7476 8.22616 12.4557 8.83466 11.4187 10.6229C11.0723 11.2201 11.2757 11.985 11.8729 12.3313C12.4701 12.6777 13.235 12.4743 13.5813 11.8771ZM15 20C15.6904 20 16.25 19.4404 16.25 18.75C16.25 18.0596 15.6904 17.5 15 17.5C14.3096 17.5 13.75 18.0596 13.75 18.75C13.75 19.4404 14.3096 20 15 20Z"
      fill={fill}
      fillRule="evenodd"
    />
  </svg>
);
